import { present } from '@cian/newbuilding-utils';
import { IRegion } from '../../types/regions';

export function isArea(region: IRegion) {
  return present(region.mainTownId);
}
